import { apiFetch } from '@/lib/api-client';
import type { AddressColumnInfo, UpdateAddressColumnRequest, UpdateAddressColumnResult } from '@uniticket/shared';

// Console DMP — modifier n'importe quelle colonne d'une adresse (admins seuls, demande du user du 17-09).

const columnPath = (jvid: number, column: string) =>
  `/dmp/console/addresses/${jvid}/columns/${encodeURIComponent(column)}`;

/** Ce qu'est la colonne (type, NULL autorisé, libellés d'enum, valeur actuelle) et si l'éditeur brut peut l'écrire. */
export async function fetchAddressColumn(jvid: number, column: string) {
  return apiFetch<{ data: AddressColumnInfo }>(columnPath(jvid, column));
}

export async function updateAddressColumn(jvid: number, column: string, body: UpdateAddressColumnRequest) {
  return apiFetch<{ data: UpdateAddressColumnResult }>(columnPath(jvid, column), {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}
